import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { telegram, telegramAction, telegramTotal, telegramGraph } from "../../actions/leakedCredentials";
import BasicLineColumn from "../common/apexChart/lineChart";
import Pagination from "../Pagination/Pagination";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import $, { data } from "jquery";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import axios from "axios";
import { API_URL } from "../../utils/constant";
import { rescanSingle } from "../../actions/users";
import PieChart from "../../components/common/dashboard12/piechart.js";
import { format, isValid } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../assets/css/recommendation-modal.css";
import ImageModal from "../common/ImageModal";


const TelegramMonitoring = () => {
  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });
  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );
  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.de?.e;
  });
  const dispatch = useDispatch();
  const [toggleArray, setToggleArray] = useState({});
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState([]);
  const [search, setSearch] = useState("");
  const [filterData, setfilterData] = useState("all");
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);
  const [isModalTrue, setModalSet] = useState(false);
  const [detail, setdetail] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [category, setCategory] = useState("all");
  const [isModal, setModal] = useState("");
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState([]);
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [limit, setLimit] = useState(10);
  const [isRecommendationModal, setIsRecommendationModal] = useState(false);
  const [activeRecommendationTab, setActiveRecommendationTab] = useState('guide');


  const state = useSelector(
    (state) => state?.leakedCredential?.telegramData?.data?.data
  );

  const auth = useSelector((state) => state?.auth?.user);

  const totalCount = useSelector(
    (state) => state?.leakedCredential?.telegramData?.data?.totalRecords
  );

  const recordFound = useSelector(
    (state) => state?.leakedCredential?.leakedres?.data?.totalTelegramForumRecords
  );

  const telegramGraphData = useSelector(
    (state) => state?.leakedCredential?.telegramGraph?.data || state?.leakedCredential?.telegramGraph
  );

  const graphDates = telegramGraphData?.dates || [];
  const graphCounts = telegramGraphData?.scanDetails || telegramGraphData?.counts || telegramGraphData?.values || telegramGraphData?.data || [];

  useEffect(() => {
    telegram(id, dispatch, page, category, startDate, endDate, limit);
  }, [id, dispatch, page, category, startDate, endDate, limit]);

  useEffect(() => {
    setTotalItems(totalCount)
  }, [totalCount])

  useEffect(() => {
    telegramTotal(id, dispatch)
  }, [id, dispatch])

  useEffect(() => {
    telegramGraph(id, dispatch);
  }, [id, dispatch]);


  const addModal = () => {
    setModal("Form Wizard modal");
  };

  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);

  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };

  const snooze = (_id, event) => {
    if (event == "") {
    }

    if (event == "riskAccepted") {
    }

    if (event == "markAsFalsePositive") {
    }

    if (event === "markAsRemidiated") {
      $.confirm({
        title: "Are you sure?",
        content: "Do you really want to mark this as remediated?",
        type: "green",
        buttons: {
          ok: {
            text: "Yes, Mark as Remediated",
            btnClass: "btn-success",
            keys: ["enter"],
            action: function () {
              let ids = [];
              ids.push(_id);
              const data = {
                action: "markAsRemediated",
                recordIds: selectedIds.length === 0 ? ids : selectedIds,
                actionNote: "",
                for: "forever",
              };
              telegramAction(id, dispatch, page, category, data, limit);
              setSelectedValue("pleaseSelect");
              setActionNote("");
              setSelectedIds([]);
            },
          },
          cancel: function () {
            // User canceled, do nothing
          },
        },
      });
    }

  };

  const Unsnoozed = (_id) => {
    let ids = [];
    ids.push(_id);
    const data = {
      action: 'resetAction',
      recordIds: selectedIds == 0 ? ids : selectedIds,
    };
    telegramAction(id, dispatch, page, category, data, limit);
    setSelectedIds([]);
  }

  const submit = () => {
    const data = {
      action: action,
      recordIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    telegramAction(id, dispatch, page, category, data, limit);
    setModal("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
  };


  const [hasPushedData, setHasPushedData] = useState(false);

  let mapData = state;

  let currentTableData = [];
  if (mapData && mapData.length > 0) {
    currentTableData = mapData;
  }

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/telegram-monitoring/${id}/excel`,

        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}Telegram Monitoring.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  const reScan = () => {
    let data = {
      "moduleName": ["telegram"]
    }
    rescanSingle(id, data)
  }


  // Add these new state variables for date picker
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [tempStartDate, setTempStartDate] = useState(null);
  const [tempEndDate, setTempEndDate] = useState(null);
  const [startDateObj, setStartDateObj] = useState(null);
  const [endDateObj, setEndDateObj] = useState(null);
  const [isUrlWarningModal, setIsUrlWarningModal] = useState(false);
  const [selectedUrl, setSelectedUrl] = useState("");
  const [isAttachmentPreviewOpen, setIsAttachmentPreviewOpen] = useState(false);
  const [previewAttachmentUrl, setPreviewAttachmentUrl] = useState("");

  // Update startDateObj and endDateObj whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setStartDateObj(new Date(startDate));
    }
    if (endDate) {
      setEndDateObj(new Date(endDate));
    }
  }, [startDate, endDate]);

  // Update tempStartDate and tempEndDate whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setTempStartDate(new Date(startDate));
    }
    if (endDate) {
      setTempEndDate(new Date(endDate));
    }
  }, [startDate, endDate]);

  // Add this function to format the displayed date range
  const formatDateRange = () => {
    if (startDate && endDate) {
      return `Selected date: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''} to ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    } else if (startDate) {
      return `From: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''}`;
    } else if (endDate) {
      return `Till: ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    }
    return "Select date range"; // Default placeholder text
  };

  // Add this function to handle applying the selected date range
  const applyDateRange = () => {
    if (tempStartDate) {
      setStartDate(format(tempStartDate, 'yyyy-MM-dd'));
    } else {
      setStartDate('');
    }

    if (tempEndDate) {
      setEndDate(format(tempEndDate, 'yyyy-MM-dd'));
    } else {
      setEndDate('');
    }

    setDatePickerOpen(false);
    setPage(1);
  };

  // Add this function to clear all dates
  const cancelDateSelection = () => {
    setTempStartDate(null);
    setTempEndDate(null);
    setStartDate('');
    setEndDate('');
    setStartDateObj(null);
    setEndDateObj(null);
    setDatePickerOpen(false);
  };

  // Handle URL confirmation for external links
  const handleUrlConfirm = () => {
    if (selectedUrl) {
      window.open(selectedUrl, '_blank');
    }
    setIsUrlWarningModal(false);
    setSelectedUrl("");
  };

  // Handle attachment preview
  const handleAttachmentPreview = (url) => {
    if (!url) return;
    setPreviewAttachmentUrl(url);
    setIsAttachmentPreviewOpen(true);
  };


  return (
    <div className="container-fluid">
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h1 className="welcome-text">Telegram monitoring</h1>
            <nav aria-label="breadcrumb" className="mt-1">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  {vendorId ? <>
                    <Link to="/vendor"
                      onClick={(() => {
                        sessionStorage.clear();
                      })}
                    >Vendor Assessment</Link>
                  </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                </li>
                {
                  vendorName ?
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                      style={{ color: "white" }}
                    >
                      <Link to={`/dashboard/vendor/${vendorId}`}
                      >{vendorName}</Link>
                    </li> : ''
                }
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                  style={{ color: "white" }}
                >
                  Telegram Monitoring
                </li>
              </ol>
            </nav>
          </div>
          <div className="col-md-6 col-sm-12 hidden-xs d-flex justify-content-end align-items-center">
            <span>
              {auth?.accessLevel == "Admin" && (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    reScan();
                  }}
                  style={{ color: "black", fontWeight: "bold" }}
                  className="btn btn-primary mr-1"
                >
                  Rescan
                </a>
              )}
            </span>
            <span className="mr-2">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  setIsRecommendationModal(true);
                }}
                href="#"
                className="btn btn-sm btn-primary mr-1"
                style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
              >
                <i className="fa fa-lightbulb-o" style={{ fontSize: "14px" }}></i>
                Recommendation
              </a>
            </span>
            <span>
              {client?.subscriptionType != "trial" && mapData?.length !== 0 && (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    downloadFile();
                  }}
                  href="/add-report"
                  className="btn btn-sm btn-primary mr-1 download-report"
                >
                  Download Details
                </a>
              )}
            </span>
          </div>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-lg-4 col-md-12">
          <div className="card RecordFoundCard">
            <div className="body" style={{ minHeight: "460px" }}>
              {/* <div className="header">
                  <h2>Details</h2>
                </div> */}
              <h6 className="mb-3 welcome-textSmall">Records Found</h6>
              <div className="d-flex mb-4 justify-content-center">
                {recordFound && <PieChart series={[recordFound]} label={["recordFound"]} />}
              </div>

              {/* <div className="form-group">
                <label className="d-block" style={{ cursor: 'pointer' }} onClick={() => setfilterData("plain")}>
                  Plain Text Password{" "}
                  <span className="float-right">
                    {plainPasswordPercent?.toFixed(0)}%
                  </span>
                </label>
                <div className="progress progress-xxs">
                  <div
                    className="progress-bar progress-bar-success"
                    role="progressbar"
                    aria-valuenow={plainPasswordPercent?.toFixed(0)}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: plainPasswordPercent?.toFixed(0) + "%" }}
                  ></div>
                </div>
              </div> */}

              {/* <div className="form-group">
                <label className="d-block" style={{ cursor: 'pointer' }} onClick={() => setfilterData("multiple")}>
                  Users Breached Multiple Times{" "}
                  <span className="float-right">
                    {breachedPercent?.toFixed(0)}%
                  </span>
                </label>
                <div className="progress progress-xxs">
                  <div
                    className="progress-bar progress-bar-warning"
                    role="progressbar"
                    aria-valuenow={breachedPercent?.toFixed(0)}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: breachedPercent?.toFixed(0) + "%" }}
                  ></div>
                </div>
              </div> */}

              {/* <div className="form-group">
                <label className="d-block" style={{ cursor: 'pointer' }} onClick={() => setfilterData("contact")}>
                  Contact Number/ address found{" "}
                  <span className="float-right">
                    {phonePasswordPercent?.toFixed(0)}%
                  </span>
                </label>
                <div className="progress progress-xxs">
                  <div
                    className="progress-bar progress-bar-info"
                    role="progressbar"
                    aria-valuenow={phonePasswordPercent?.toFixed(0)}
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: phonePasswordPercent?.toFixed(0) + "%" }}
                  ></div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div className="col-lg-8 col-md-12 col-sm-12">
          <div className="card">
            <div className="body" style={{ minHeight: "460px" }}>
              <h6 className="welcome-textSmall">Previous scan details</h6>
              {graphDates?.length > 0 && graphCounts?.length > 0 && (
                <BasicLineColumn
                  dates={graphDates}
                  ipArray={graphCounts}
                  color={["#453acd"]}
                  yAxis="Records Found"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
        <li className="nav-item">
          <a
            className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("all");
              setPage(1);
              setfilterData("all");
              setSelectedIds([]);
            }}
          >
            Current
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("risk-accepted");
              setPage(1);
              setfilterData("all");
              setSelectedIds([]);
            }}
          >
            Risk Accepted
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("false-positive");
              setPage(1);
              setfilterData("all");
              setSelectedIds([]);
            }}
          >
            False Positive
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
              }`}
            onClick={() => {
              setCategory("remidiated");
              setPage(1);
              setfilterData("all");
              setSelectedIds([]);
            }}
          >
            Remediated
          </a>
        </li>
      </ul>
      <div className="card card_tableBox">
        <div className="body">
          <div className="row mb-2">
            <div className="col-sm-3 mb-2">
              <div className="date-picker-container">
                <div className="date-range-input">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Select date range"
                    value={formatDateRange()}
                    onClick={() => setDatePickerOpen(true)}
                    readOnly
                  />
                  <span className="calendar-icon">
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </div>
            <div className="col-sm-3 mb-2">
              {selectedIds.length > 1 && userPermission && category === "all" && (
                <Box sx={{ width: 160 }}>
                  <FormControl fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedValue}
                      onChange={(event) => {
                        setAction(event.target.value);
                        snooze("", event.target.value);
                      }}
                    >
                      <MenuItem value="pleaseSelect">Snooze Options</MenuItem>
                      <MenuItem
                        value="riskAccepted"
                        onClick={() => {
                          addModal();
                        }}
                      >
                        Risk Accepted
                      </MenuItem>
                      <MenuItem
                        value="markAsFalsePositive"
                        onClick={() => {
                          addModal();
                        }}
                      >
                        False Positive
                      </MenuItem>
                      <MenuItem value="markAsRemidiated">Remediated</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              )}
              {selectedIds.length > 1 && userPermission &&
                (category == "false-positive" ||
                  category == "risk-accepted") && (
                  <button
                    className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                    onClick={() => Unsnoozed("")}
                  >
                    Unsnooze
                  </button>
                )}
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-custom spacing5 mb-0">
              <thead>
                <tr>
                  {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                    category === "risk-accepted" ||
                    category === "false-positive") && (
                      <th>
                        <input
                          type="checkbox"
                          checked={selectedIds == 0 ? false : multiCheckTrue}
                          onClick={() => {
                            multicheck(currentTableData);
                          }}
                          className="checkUncheck"
                        />
                      </th>
                    )}
                  <th>Message</th>
                  <th>Telegram Group</th>
                  <th>Message Link</th>
                  <th>Chat Detail</th>
                  <th>Date</th>
                  {category != "all" && <th>Action Note</th>}
                  {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                    category === "risk-accepted" ||
                    category === "false-positive") && (
                      <th>Action</th>
                    )}
                </tr>
              </thead>
              <tbody>
                {currentTableData?.map((row, index) => {
                  return (
                    <tr>
                      {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                        category === "risk-accepted" ||
                        category === "false-positive") && (
                          <td>
                            <input
                              onClick={() => singleClick(row?._id)}
                              checked={selectedIds?.includes(row?._id)}
                              type="checkbox"
                              className="checkUncheck"
                            />
                          </td>
                        )}
                      <td
                        title={row?.message}
                        style={{
                          maxWidth: "250px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >{row?.message ? row?.message : "N/A"}</td>

                      <td>{row?.group_name ? row?.group_name : "N/A"}</td>
                      <td>
                        <a href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            if (row?.message_link) {
                              setSelectedUrl(row.message_link);
                              setIsUrlWarningModal(true);
                            }
                          }}
                          style={{
                            maxWidth: "250px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            cursor: row?.message_link ? "pointer" : "default",
                            color: row?.message_link ? "#007bff" : "#666"
                          }}
                        >
                          {row?.message_link ? row?.message_link : "N/A"}
                        </a>
                      </td>
                      <td>
                        <Link to="#" className="mr-2"
                          onClick={() => {
                            setModalSet(true);
                            setdetail(row?.message)
                          }}>
                          Detail
                        </Link>
                        {row?.s3_media_url ? (
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleAttachmentPreview(row?.s3_media_url);
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Attachment
                          </a>) : (null)}

                      </td>
                      <td>{row?.date}</td>
                      {category !== "all" && <td style={{ whiteSpace: "unset" }}>{row?.actionNote ? row.actionNote : "N/A"}</td>}
                      {auth?.accessLevel != "Threat Analyst" && userPermission && category === "all" && (
                        <td>
                          <Box sx={{ width: 160 }}>
                            <FormControl fullWidth>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectedValue}
                                onChange={(event) => {
                                  setAction(event.target.value);
                                  snooze(row?._id, event.target.value);
                                }}
                              >
                                <MenuItem value="pleaseSelect">
                                  Snooze Options
                                </MenuItem>
                                <MenuItem
                                  value="riskAccepted"
                                  onClick={() => {
                                    addModal();
                                    setLookalikeAppId([row._id]);
                                  }}
                                >
                                  Risk Accepted
                                </MenuItem>
                                <MenuItem
                                  value="markAsFalsePositive"
                                  onClick={() => {
                                    addModal();
                                    setLookalikeAppId([row._id]);
                                  }}
                                >
                                  False Positive
                                </MenuItem>
                                <MenuItem value="markAsRemidiated">
                                  Remediated
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </Box>
                        </td>
                      )}
                      {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "risk-accepted" || category === "false-positive") && (
                        <td>
                          <button
                            className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                            onClick={() => Unsnoozed(row?._id)}
                          >
                            Unsnooze
                          </button>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-between align-content-center">
            <div className="dataTables_paginate">
              {totalItems > 0 && (
                <Pagination
                  className="pagination-bar"
                  currentPage={page}
                  totalCount={totalItems}
                  pageSize={limit}
                  onPageChange={(page) => setPage(page)}
                />
              )}
            </div>
            {totalItems > 10 && (
              <select
                value={limit}
                onChange={(e) => {
                  setLimit(e.target.value)
                }}
                className="form-control limitSelectBox"
              >
                <option value={10}>10 per page</option>
                <option value={25}>25 per page</option>
                <option value={50}>50 per page</option>
                <option value={100}>100 per page</option>
              </select>
            )}
          </div>
        </div>
      </div>
      <div
        className={`modal fade Form-Wizard-modal ${isModalTrue == true ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Details
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setModalSet(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card">
                  <p>
                    Message - &nbsp {detail}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Add the date picker overlay */}
      {datePickerOpen && (
        <div className="date-range-overlay" onClick={() => setDatePickerOpen(false)}>
          <div className="date-range-picker-popup" onClick={(e) => e.stopPropagation()}>
            <div className="date-range-picker-header">
              {tempStartDate && tempEndDate
                ? `Selected date: ${format(tempStartDate, 'MM/dd/yyyy')} to ${format(tempEndDate, 'MM/dd/yyyy')}`
                : "Select date range"}
            </div>
            <div className="date-range-calendars">
              <div>
                <h6>From</h6>
                <DatePicker
                  selected={tempStartDate}
                  onChange={(date) => {
                    setTempStartDate(date);
                    if (tempEndDate && date > tempEndDate) {
                      setTempEndDate(null);
                    }
                  }}
                  selectsStart
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
              <div>
                <h6>To</h6>
                <DatePicker
                  selected={tempEndDate}
                  onChange={(date) => setTempEndDate(date)}
                  selectsEnd
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  minDate={tempStartDate}
                  inline
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>
            </div>
            <div className="date-range-actions">
              <button
                className="date-range-apply"
                onClick={applyDateRange}
              >
                Apply Filter
              </button>
              <button
                className="date-range-cancel"
                onClick={cancelDateSelection}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Recommendation Modal */}
      {isRecommendationModal && (
        <div className="recommendation-modal-overlay" onClick={() => setIsRecommendationModal(false)}>
          <div className="recommendation-modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="recommendation-modal-close" onClick={() => setIsRecommendationModal(false)}>
              &times;
            </button>

            <div className="recommendation-modal-content">
              <div className="recommendation-tabs">
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'guide' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('guide')}
                >
                  Guidance
                </button>
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('checklist')}
                >
                  Action Checklist
                </button>
              </div>

              <div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
                <div className="guide-intro">
                  Telegram channels, groups, and bots are frequently used to circulate breached data, phishing kits, and access credentials. Monitoring these spaces helps catch brand abuse and leaked assets early.
                </div>

                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>What We Monitor</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Public and invite-only channels mentioning the brand or domains</li>
                      <li>File drops containing credentials, PII, or internal documents</li>
                      <li>Bots sharing phishing pages or fake support workflows</li>
                      <li>Lists of compromised accounts, API keys, or access tokens</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Threat Use Cases</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Brand impersonation channels collecting user credentials</li>
                      <li>Sale of stealer logs or session cookies targeting your org</li>
                      <li>Phishing kits and payment scams distributed via bots</li>
                      <li>Leaks of internal documents, API endpoints, or source snippets</li>
                    </ul>
                  </div>
                </details>
              </div>

              <div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Validate & Contain</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Verify authenticity of leaked data or screenshots</li>
                      <li>Escalate takedown or abuse reports to Telegram with evidence</li>
                      <li>Preserve chat/file evidence for incident tracking</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.16.1.2 · Incident Response</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Credential & Account Protection</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Force resets for exposed accounts; revoke tokens/sessions</li>
                      <li>Enable MFA and conditional access for impacted users</li>
                      <li>Review access logs for abuse of mentioned accounts</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.9.4.3 · DPDPA</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Brand Protection</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Request removal of impersonating channels and bots</li>
                      <li>Publish official support handles to reduce victimization</li>
                      <li>Track repeat offenders and report to legal if required</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.6.8 · Brand Protection</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Ongoing Monitoring</h3>
                      <span className="severity-badge low">Low</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Subscribe to alerts for new channel mentions and reposts</li>
                      <li>Document incident timelines and update risk register</li>
                      <li>Align learnings with threat intel and SOC playbooks</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.16.1.4 · Threat Intelligence</div>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* URL Warning Modal */}
      {isUrlWarningModal && (
        <div className={`modal fade Form-Wizard-modal ${isUrlWarningModal ? "d-block show" : ""}`}>
          <div className="modal-dialog" id="urlWarningModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">External Link Warning</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setIsUrlWarningModal(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="alert alert-warning mb-3">
                  <i className="fa fa-exclamation-triangle mr-2"></i>
                  You are about to leave this site and visit an external URL. This link may lead to a third-party website. Please proceed with caution.
                </div>
                <p className="mb-0">URL: <strong>{selectedUrl}</strong></p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={() => setIsUrlWarningModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleUrlConfirm}
                >
                  Proceed Anyway
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <ImageModal
        isOpen={isAttachmentPreviewOpen}
        onClose={() => {
          setIsAttachmentPreviewOpen(false);
          setPreviewAttachmentUrl("");
        }}
        imageSrc={previewAttachmentUrl}
      />

      <div
        className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
          }`}
      >
        <div className="modal-dialog modal-lg" id="clientModal">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {action == "markAsFalsePositive"
                  ? "Mark As False Positive"
                  : "Risk Accepted"}
              </h5>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setModal("");
                  setActionNote("");
                }}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body pricing_page modal_mob">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="card">
                  <div className="row clearfix">
                    <div className="col-md-12">
                      <label className="col-lg-6 col-md-12">Snooze for</label>
                      <div className="form-group ol-lg-12 col-md-12">
                        <select
                          className="custom-select custom-select-sm form-control form-control-sm"
                          onChange={(e) => setForValue(e.target.value)}
                        >
                          <option value="forever">Forever</option>
                          <option value="3 months">3 Months</option>
                          <option value="6 months">6 Months</option>
                          <option value="12 months">12 Months</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <label className="col-lg-12 col-md-12">Detail</label>
                      <div className="form-group col-lg-12 col-md-12">
                        <textarea
                          onChange={(e) => setActionNote(e.target.value)}
                          value={actionNote}
                          className="form-control"
                          rows="3"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className="col-lg-12 col-md-12"
                      style={{ marginRight: "28px" }}
                    >
                      <button
                        type="button"
                        style={{ color: "black", fontWeight: "bold" }}
                        onClick={submit}
                        className="btn btn-round btn-primary mr-1 pull-right"
                      >
                        Submit
                      </button>
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        onClick={() => {
                          setModal("");
                          setActionNote("");
                        }}
                        className="btn btn-round btn-default pull-right"
                        style={{ marginRight: "10px" }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TelegramMonitoring;
